/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Section_2_CInputs */



/**
* | output |
* | --- |
* | "False positives may occur, where legitimate requests are incorrectly blocked" |
*
* @param {Guardrails_Section_2_CInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_section_2_c = /** @type {((inputs?: Guardrails_Section_2_CInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Section_2_CInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("FALSE POSITIVES auftreten können, bei denen legitime Anfragen fälschlicherweise blockiert werden")
	return /** @type {LocalizedString} */ ("False positives may occur, where legitimate requests are incorrectly blocked")
});